import { fetchGetMeta, TGetMetaResponse } from '../../repositories/search-offers-index/v1/get-meta';
import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../errors';
import { IJsonQuery } from '../../utils/jsonQuery';
import { ISearchMeta } from '../../types/searchMeta';
import { prepareSearchMeta } from '../../mappers/prepareSearchMeta';

interface IFetchSearchMetaParameters {
  jsonQuery: IJsonQuery;
  cancelationTokenKey?: string;
}

export async function fetchSearchMeta(
  { httpApi }: IApplicationContext,
  { jsonQuery }: IFetchSearchMetaParameters,
): Promise<ISearchMeta> {
  const searchMetaData: TGetMetaResponse = await fetchGetMeta({
    httpApi,
    parameters: {
      jsonQuery,
    },
  });

  if (searchMetaData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchSearchMeta',
      message: searchMetaData.response.message || '',
      details: {
        error: JSON.stringify(searchMetaData.response.errors),
      },
    });
  }

  return prepareSearchMeta(searchMetaData.response);
}
